import {
    CloseCircleOutlined
} from '@ant-design/icons';
import { Card, Collapse, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import st from './style.module.css';

import AlbertHappy from "../../assets/images/albert/status/Happy.svg";
import AlbertSad from "../../assets/images/albert/status/Sad.svg";
import CoinsStar from "../../assets/images/app/coins.svg";
import { ReactComponent as GamificationOne } from "../../assets/images/app/gamification_1.svg";
import { ReactComponent as GamificationTwo } from "../../assets/images/app/gamification_2.svg";
import { ReactComponent as GamificationThree } from "../../assets/images/app/gamification_3.svg";
import { ReactComponent as GamificationFour } from "../../assets/images/app/gamification_4.svg";
import { ReactComponent as GamificationFive } from "../../assets/images/app/gamification_5.svg";

const { Text } = Typography;
const { Panel } = Collapse;

interface GamificationCardProps {
    icon: React.ReactNode;
    description: string;
}

const GamificationCard: React.FC<GamificationCardProps> = ({ icon, description }) => {
    return (
        <Card
            hoverable
            className={st.gamificationCard}
            bordered
        >
            <div className={st.cardIcon}>{icon}</div>
            <div className={st.cardDescription} dangerouslySetInnerHTML={{ __html: description }} />
        </Card>
    );
};

interface GamificationProps {
    data: any;
    userType: string;
    displayedFromOnboarding: boolean;
}

const Gamification: React.FC<GamificationProps> = ({ data, userType, displayedFromOnboarding }) => {

    const [currentTab, setCurrentTab] = useState<any>(1);
    const [bonusData, setBonusData] = useState<any>();
    const [malusData, setMalusData] = useState<any>();
    const [reservationData, setReservationData] = useState<any>();
    const [activeKey, setActiveKey] = useState<string | string[]>('0');

    const [isMobile, setIsMobile] = useState(window.innerWidth <= 1050);
    const handleResize = () => {
        setIsMobile(window.innerWidth <= 1050);
    };
    window.addEventListener('resize', handleResize);

    const earnPointsCards = [
        {
            icon: <GamificationOne style={{ height: "35px" }} />,
            description: "Participes<br/>à un cours avec<br/>un professeur."
        },
        {
            icon: <GamificationTwo style={{ height: "35px" }} />,
            description: "Réponds à des quiz<br/>et challenges<br/>dans une classe."
        },
        {
            icon: <GamificationThree style={{ height: "35px" }} />,
            description: "Notes ton<br/>professeur après<br/>une séance."
        },
        {
            icon: <GamificationFour style={{ height: "35px" }} />,
            description: "Parraines<br/>un ami qui s'inscrit<br/>via ton lien."
        },
        {
            icon: <GamificationFive style={{ height: "35px" }} />,
            description: "Interagis<br/>dans les classes<br/>et commentaires."
        }
    ];

    const earnPointsCardsTeacher = [
        {
            icon: <GamificationOne style={{ height: "35px" }} />,
            description: "Dès ton inscription<br/>sur<br/>MonAmiAlbert."
        },
        {
            icon: <GamificationThree style={{ height: "35px" }} />,
            description: "Notes ton<br/>élève après<br/>une séance."
        },
        {
            icon: <GamificationFour style={{ height: "35px" }} />,
            description: "Parraines<br/>des élèves & profs<br/>via ton lien."
        },
        {
            icon: <GamificationFive style={{ height: "35px" }} />,
            description: "Renforce<br/>ta présence et ta visibilité<br/>sur la plateforme."
        }
    ];

    const handlePanelChange = (key: string | string[]) => {
        setActiveKey(key);
    };

    useEffect(() => {
        if (data) {
            setBonusData(data?.bonus);
            setMalusData(data?.malus);
            setReservationData(data?.reservation);
        }
    }, [data]);

    return (
        <div className={displayedFromOnboarding ? st.gamificationMain : st.gamificationContainer}>
            <div className={displayedFromOnboarding ? st.gamificationTitleMain : st.gamificationTitle}>{displayedFromOnboarding ? "Gamification" : userType === "teacher" ? "Gagne des points pour chaque action effectuée … et donc plus d’argent!" : "Avec Albert ton engagement est récompensé !"}</div>

            {userType === "teacher" ? <div className={displayedFromOnboarding ? st.gamificationIntroMain : st.gamificationIntro}>
                Nous croyons que l’engagement doit être récompensé! Avec Albert, quand tu t’engages et interagis<br />sur la plateforme, tu es récompensé! Plus tu as de points, plus grande est notre amitié, et <br />moins la commission que nous prélevons sur les cours que tu donnes est importante!
            </div> : <div className={displayedFromOnboarding ? st.gamificationIntroMain : st.gamificationIntro}>
                Sur Mon Ami Albert, plus tu t'impliques, plus tu gagnes !<br />
                Tu accumules des points, des scores, et tu peux même améliorer ton classement.<br />
                Alors sois actif, et fais briller ton profil dans ton pays et ton établissement !
            </div>}

            <div className={st.pointsSection}>
                <div className={displayedFromOnboarding ? st.sectionTitleOnboarding : st.sectionTitle}>Tu gagnes des points quand tu...</div>

                {userType === "teacher" ? <div className={displayedFromOnboarding ? st.cardsContainerOnboarding : st.cardsContainer}>
                    {earnPointsCardsTeacher.map((card, index) => (
                        <GamificationCard
                            icon={card.icon}
                            description={card.description}
                            key={index}
                        />
                    ))}
                </div> : <div className={displayedFromOnboarding ? st.cardsContainerOnboarding : st.cardsContainer}>
                    {earnPointsCards.map((card, index) => (
                        <GamificationCard
                            icon={card.icon}
                            description={card.description}
                            key={index}
                        />
                    ))}
                </div>}

                {userType === "teacher" ? <div className={displayedFromOnboarding ? st.sectionNoteOnboarding : st.sectionNote}>
                    Ces actions te donnent des points (des bonus à utiliser dans la plateforme)
                    <br />
                    et font augmenter ton score général, qui te classe parmi les meilleurs professeurs.
                </div> : <div className={displayedFromOnboarding ? st.sectionNoteOnboarding : st.sectionNote}>
                    Ces actions te donnent des points (des bonus à utiliser dans la plateforme)
                    <br />
                    et font augmenter ton score général, qui te classe parmi les meilleurs élèves
                    <br />
                    de ton pays et de ton établissement.
                </div>}
            </div>

            <div className={st.losePointsSection}>
                <div className={displayedFromOnboarding ? st.sectionTitleOnboarding : st.sectionTitle}>Tu perds des points quand tu...</div>

                {userType === "teacher" ? <div style={{ display: "flex", flexDirection: "column", alignContent: "center", justifyContent: "center", textAlign: "left", width: "75%" }}>
                    <div className={displayedFromOnboarding ? st.losePointItemOnboarding : st.losePointItem}>
                        <CloseCircleOutlined style={{ fontSize: '20px', color: '#ff4d4f' }} />
                        <Text>Le fait de ne donner aucun cours pendant un mois va te faire perdre beaucoup de points!</Text>
                    </div>
                    <div className={displayedFromOnboarding ? st.losePointItemOnboarding : st.losePointItem}>
                        <CloseCircleOutlined style={{ fontSize: '20px', color: '#ff4d4f' }} />
                        <Text>De même, les annulations de cours sans reprogrammation.</Text>
                    </div>
                    <div className={displayedFromOnboarding ? st.losePointItemOnboarding : st.losePointItem}>
                        <CloseCircleOutlined style={{ fontSize: '20px', color: '#ff4d4f' }} />
                        <Text>Une note reçue post-cours inférieure à 3.</Text>
                    </div>
                    <div className={displayedFromOnboarding ? st.losePointItemOnboarding : st.losePointItem}>
                        <CloseCircleOutlined style={{ fontSize: '20px', color: '#ff4d4f' }} />
                        <Text>le non-respect des normes de la plateforme.</Text>
                    </div>
                </div> : <div className={displayedFromOnboarding ? st.losePointItemOnboarding : st.losePointItem}>
                    <CloseCircleOutlined style={{ fontSize: '20px', color: '#ff4d4f' }} />
                    <Text>Annules un cours sans prévenir ou ne te présentes pas.</Text>
                </div>}

                <div className={displayedFromOnboarding ? st.losePointNoteOnboarding : st.losePointNote}>
                    Pas d'inquiétude ! Tes points peuvent remonter rapidement si tu es régulier et motivé !
                </div>
            </div>

            <div className={st.tabBox}>
                {userType === "teacher" && <div className={st.tabHeaderBox}>
                    <div className={displayedFromOnboarding ? st.successHeaderOnboarding : st.successHeader} style={{ boxShadow: currentTab === 1 ? "3px 6px 12px #7E7E7E29" : "" }} onClick={() => setCurrentTab(1)}><img src={AlbertHappy} height={isMobile ? 25 : 55} style={{ marginRight: "10px" }}></img>BONUS PROF</div>
                    <div className={displayedFromOnboarding ? st.errorHeaderOnboarding : st.errorHeader} style={{ boxShadow: currentTab === 2 ? "3px 6px 12px #7E7E7E29" : "" }} onClick={() => setCurrentTab(2)}><img src={AlbertSad} height={isMobile ? 25 : 55} style={{ marginRight: "10px" }}></img>MALUS PROF</div>
                </div>}

                {userType === "student" && <div className={st.tabHeaderBox}>
                    <div className={displayedFromOnboarding ? st.successHeaderOnboarding : st.successHeader} style={{ boxShadow: currentTab === 1 ? "3px 6px 12px #7E7E7E29" : "" }} onClick={() => setCurrentTab(1)}><img src={AlbertHappy} height={isMobile ? 25 : 55} style={{ marginRight: "10px" }}></img>BONUS ELEVE</div>
                    <div className={displayedFromOnboarding ? st.errorHeaderOnboarding : st.errorHeader} style={{ boxShadow: currentTab === 2 ? "3px 6px 12px #7E7E7E29" : "" }} onClick={() => setCurrentTab(2)}><img src={AlbertSad} height={isMobile ? 25 : 55} style={{ marginRight: "10px" }}></img>MALUS ELEVE</div>
                    {/* <div className={displayedFromOnboarding ? st.successHeaderOnboarding : st.successHeader} style={{ boxShadow: currentTab === 3 ? "3px 6px 12px #7E7E7E29" : "" }} onClick={() => setCurrentTab(3)}><img src={AlbertHappy} height={isMobile ? 25 : 55} style={{ marginRight: "10px" }}></img>RESERVATIONS</div> */}
                </div>}

                <div className={st.tabContent}>
                    {currentTab === 1 && bonusData && <Collapse accordion activeKey={activeKey} onChange={handlePanelChange} expandIconPosition="end" style={{ borderRadius: '0', background: "#FFF" }}>
                        {(Object.entries(bonusData) as [string, any[]][]).map(([title, rules]) => (
                            <Panel
                                header={<p className={st.question}>{title}</p>}
                                key={title + rules.length}
                                style={{ borderRadius: '0', background: "#FFF" }}
                            >
                                <div className={st.tabContentBox}>
                                    {!isMobile && <div className={displayedFromOnboarding ? st.tabContentBoxHeaderOnboarding : st.tabContentBoxHeader}>
                                        <div className={st.tabContentBoxHeaderAction}>
                                            <div className={st.tabContentBoxHeaderDot} style={{ marginRight: "5px" }}></div>
                                            Action
                                        </div>
                                        <div className={st.tabContentBoxHeaderAction}>
                                            Coins
                                            <div className={st.tabContentBoxHeaderDot} style={{ marginLeft: "5px" }}></div>
                                        </div>
                                    </div>}

                                    {rules.map((rule: any, i: number) => (
                                        <div className={st.messageBox} key={i}>
                                            {isMobile && <div className={st.tabContentBoxHeaderAction}>
                                                <div className={st.tabContentBoxHeaderDot} style={{ marginRight: "5px" }}></div>
                                                Action
                                            </div>}
                                            <div className={displayedFromOnboarding ? st.textBoxOnboarding : st.textBox} dangerouslySetInnerHTML={{ __html: rule?.onboarding }} />
                                            {isMobile && <div className={st.tabContentBoxHeaderAction}>
                                                Coins
                                                <div className={st.tabContentBoxHeaderDot} style={{ marginLeft: "5px" }}></div>
                                            </div>}
                                            <div className={displayedFromOnboarding ? st.coinsBoxOnBoarding : st.coinsBox}>+ {" "}{rule?.points} <img src={CoinsStar} height={20} style={{ marginLeft: "5px" }}></img></div>
                                        </div>
                                    ))}
                                </div>
                            </Panel>
                        ))}
                    </Collapse>}

                    {currentTab === 2 && malusData && <Collapse accordion activeKey={activeKey} onChange={handlePanelChange} expandIconPosition="end" style={{ borderRadius: '0', background: "#FFF" }}>
                        {(Object.entries(malusData) as [string, any[]][]).map(([title, rules]) => (
                            <Panel
                                header={<p className={st.question}>{title}</p>}
                                key={title + rules.length}
                                style={{ borderRadius: '0', background: "#FFF" }}
                            >
                                <div className={st.tabContentBox}>
                                    <div className={st.tabContentBoxHeader}>
                                        <div className={st.tabContentBoxHeaderAction}>
                                            <div className={st.tabContentBoxHeaderDot} style={{ marginRight: "5px" }}></div>
                                            Action
                                        </div>
                                        <div className={st.tabContentBoxHeaderAction}>
                                            Coins
                                            <div className={st.tabContentBoxHeaderDot} style={{ marginLeft: "5px" }}></div>
                                        </div>
                                    </div>

                                    {rules.map((rule: any, i: number) => (
                                        <div className={st.messageBox} key={i}>
                                            <div className={displayedFromOnboarding ? st.textBoxOnboarding : st.textBox} dangerouslySetInnerHTML={{ __html: rule?.onboarding }} />
                                            <div className={displayedFromOnboarding ? st.coinsBoxOnBoarding : st.coinsBox}>{rule?.points} <img src={CoinsStar} height={20} style={{ marginLeft: "5px" }}></img></div>
                                        </div>
                                    ))}
                                </div>
                            </Panel>
                        ))}
                    </Collapse>}

                    {/* {currentTab === 3 && reservationData && <Collapse accordion activeKey={activeKey} onChange={handlePanelChange} expandIconPosition="end" style={{ borderRadius: '0', background: "#FFF" }}>
                        {(Object.entries(reservationData) as [string, any[]][]).map(([title, rules]) => (
                            <Panel
                                header={<p className={st.question}>{title}</p>}
                                key={title + rules.length}
                                style={{ borderRadius: '0', background: "#FFF" }}
                            >
                                <div className={st.tabContentBox}>
                                    <div className={st.tabContentBoxHeader}>
                                        <div className={st.tabContentBoxHeaderAction}>
                                            <div className={st.tabContentBoxHeaderDot} style={{ marginRight: "5px" }}></div>
                                            Action
                                        </div>
                                        <div className={st.tabContentBoxHeaderAction}>
                                            Coins
                                            <div className={st.tabContentBoxHeaderDot} style={{ marginLeft: "5px" }}></div>
                                        </div>
                                    </div>

                                    {rules.map((rule: any, i: number) => (
                                        <div className={st.messageBox} key={i}>
                                            <div className={displayedFromOnboarding ? st.textBoxOnboarding : st.textBox} dangerouslySetInnerHTML={{ __html: rule?.onboarding }} />
                                            <div className={displayedFromOnboarding ? st.coinsBoxOnBoarding : st.coinsBox}>+ {" "}{rule?.points} <img src={CoinsStar} height={20} style={{ marginLeft: "5px" }}></img></div>
                                        </div>
                                    ))}
                                </div>
                            </Panel>
                        ))}
                    </Collapse>} */}
                </div>
            </div>
        </div>
    );
};

export default Gamification;